// BusinessCardListPage の UI 状態を保存する localStorage キー
export const SEARCH_FORM_VALUES_KEY = 'business_card_search_form_values';
export const SEARCH_PARAMS_KEY = 'business_card_search_params';
export const SELECTED_CONTACT_USERS_KEY = 'business_card_selected_contact_users';
export const SCROLL_POSITION_KEY = 'business_card_scroll_position';
export const LOADED_ITEMS_COUNT_KEY = 'business_card_loaded_items_count';
export const ADVANCED_SEARCH_EXPANDED_KEY = 'business_card_advanced_search_expanded';
export const SEARCH_EXPANDED_KEY = 'business_card_search_expanded';
